import React from 'react';
import {
  FormControl,
  Box,
  FormHelperText,
  TextField,
} from '@mui/material';

import THIRD_PARTY_TYPES from '@/components/jobs/JobForm/thirdPartyTypes';

export default function OutputPathField({
  value,
  error,
  setValue,
  setError,
  setChanged,
  edit,
  outputType,
  outputUri,
  type,
}) {
  const handleChange = (event) => {
    const { value: newValue } = event.target;
    setChanged();
    setValue(newValue);

    const valid = THIRD_PARTY_TYPES.REGIONAL.uriTest.test(newValue);
    setError(!valid);
  };

  return (
    <Box>
      <FormControl fullWidth>
        <TextField
          label='Datastore path'
          id='output_path'
          aria-describedby='output-path-helper-text'
          variant='outlined'
          fullWidth
          onChange={handleChange}
          error={Boolean(error)}
          value={value || ''}
          disabled={
            !outputType ||
            !outputUri ||
            (edit && type !== 'notebook')
          }
        />
        {error ? (
          <FormHelperText id='output-path-helper-text'>
            Datastore Path Invalid
          </FormHelperText>
        ) : (
          <FormHelperText id='output-path-helper-text'>
            Enter the path within the datastore
          </FormHelperText>
        )}
      </FormControl>
    </Box>
  );
}

